import React, { Component } from 'react';
import { FullScreenViewer } from 'iv-viewer';
import "iv-viewer/dist/iv-viewer.css";


import { TEST_URL } from '../apiInfo';


export default class TestView extends Component {

	state = {
		test: null
	}

	viewer = null;
	viewerShown = false;

	componentDidMount() {
		//initiates viewer for pages
		this.viewer = new FullScreenViewer();

		const test = this.props.tests.find(test => test.id === Number(this.props.match.params.id));
		if(test){
			console.log('Showing test from props.tests from App');
			this.setState({
				test
			})
		}

		//requests the test from the server
		fetch(TEST_URL + this.props.match.params.id)
			.then(response => response.json())
			.then(response => {
				if (response.error) {
					console.error(response.errorMessage);
				} else {
					this.setState({
						test: response
					})
				}
			})
	}

	handleClickImg = (index) => {
		//shows viewer and makes sure it will be closed on exit 
		this.viewer.show(this.state.test.images[index]);
		this.viewerShown = true;
	}

	componentWillUnmount() {
		//hides viewer if it was already shown (to prevent error or scroll blocking after going back)
		if(this.viewerShown){
			this.viewer.hide();
		}
		this.viewer.destroy();
	}

	render() {
		const { test } = this.state;
		return (

			<div className="container main text-center" >

				{test ? (

					<React.Fragment>
						<div className="row">
							<div className="col-12">
								<div className="card">

									<div className="card-body text-center">
										<p className="text-primary">
											<strong>{test.subject + ': '}</strong>
											<em>{test.professor}</em>
										</p>
										<h3 className="card-title">
											<span>{test.class}</span>
											<em style={{ fontSize: '0.9em' }} >{`, ${test.day}.${test.month}.${test.year}`}</em>
										</h3>
										<p className="card-text">{test.description}</p>
									</div>

								</div>
							</div>
						</div>


						<div className="row my-4 img-row">

							{test.images.map((image, index) => (
								<div className="col-6 col-md-4 col-lg-3 img-col" key={index}>
									<button className="btn" onClick={() => this.handleClickImg(index)} >
										<img src={image} alt="" key={image} className="card img-card " />
									</button>
								</div>
							))}

						</div>
					</React.Fragment>

				) : (

						<div className="pt-3">
							<h5><i className="fas fa-spinner"></i></h5>
						</div>

					)
				}
			</div>

		)
	}
}
